export default class Notice {
	constructor(show, msg, color, timeout) {
		this.show = show;
		this.msg = msg;
		this.color = color;
		this.timeout = timeout;
	}
}